import React from 'react';
import ArchivedAssessments from '../components/AssessmentBuilder/ArchivedAssessments';

const ArchivedAssessmentsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <ArchivedAssessments asSection={false} />
    </div>
  );
};

export default ArchivedAssessmentsPage;
